















































































import { mapState } from "vuex";
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";

import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";

import TheTemplateJ from "@/general/components/templates/TheTemplateJ.vue";
import TheJPointDestination from "@/general/components/pages/parts/GiveThanksPoint/TheJPointDestination.vue";
import { Prop, Vue, Component, Ref } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import { GiveThanksPointRequest } from "gen/ricapi/api";
import globals from "@/general/store/modules/globals";
import ThanksPointApi from "@/general/api/thanksPointApi";
import sitemap from "@/general/mixins/const/custom/sitemap";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";
import loginInfo from "@/general/store/modules/loginInfo";
import AuthApi from "@/general/api/authApi";

@Component({
  components: {
    TheHeader,
    TheFooter,

    CommonHeading,
    SmallText,
    ButtonMain,

    TheTemplateJ,
    TheJPointDestination
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class GiveThanksPointConfirmation extends Vue {
  @Prop({ type: Object, default: {} }) sendTo!: any;
  @Prop({ type: Object, required: true }) sendPointConfirm!: any;
  @Prop({ type: Boolean, required: false, default: false }) ssoFlg!: boolean;
  userData!: any;

  backUrl = "";
  saving = false;
  readActivated = true;

  $refs!: {
    theHeader: TheHeader;
  };

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  @Ref("form") form!: HTMLFormElement;

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    this.ssoFlg = loginInfo.isSso;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const message = LocalStorage.getItem("message") as string;

    if (message.length > 200) {
      this.readActivated = false;
    }

    const givingType = urlParams.get("giving_type")
      ? urlParams.get("giving_type")
      : 1;

    this.backUrl =
      `${sitemap.THANKS_POINT_GIVE_THANKS_POINT}?giving_type=` + givingType;

    const userData = LocalStorage.getItem("sendToUserData") as any;
    this.userData = JSON.parse(userData);
    await commons.setOrgPageSpecificDataFromLocalStorage();
  }

  get icon() {
    return this.userData.sendTo.icon.medium;
  }

  get userName() {
    return this.userData.sendTo.name;
  }

  get giveThanksPointData(): GiveThanksPointRequest {
    const sendPoint = LocalStorage.getItem("points_to_send") as any;
    const title = LocalStorage.getItem("title") as string;
    const message = LocalStorage.getItem("message") as string;
    const id = LocalStorage.getItem("to_user") as string;
    const thanks_point_giving_type = LocalStorage.getItem(
      "thanks_point_giving_type"
    ) as string;
    return {
      points_to_send: sendPoint,
      title,
      text: message,
      to_user: parseInt(id),
      thanks_point_giving_type: parseInt(thanks_point_giving_type)
    };
  }

  get sendPointConfirmItems() {
    const unit = commons?.OrgPageSpecific?.point_name as string;
    const sendPoint = LocalStorage.getItem("points_to_send") as any;
    const resultSendPoint = `${sendPoint.toLocaleString()} ${unit}`;
    const title = LocalStorage.getItem("title");

    return [
      {
        label: "送付ポイント",
        content: resultSendPoint
      },
      {
        label: "タイトル",
        content: title
      }
    ];
  }

  get message() {
    const message = LocalStorage.getItem("message") as string;

    return [
      {
        label: "本文",
        content: message
      }
    ];
  }

  get thanksPointApprovalEnabled() {
    return auth.user?.thanks_point_approval_enabled;
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }

  async submit() {
    this.saving = true;
    const sendPoint = LocalStorage.getItem("points_to_send") as any;
    const title = LocalStorage.getItem("title") as string;
    const message = LocalStorage.getItem("message") as string;
    const id = LocalStorage.getItem("to_user") as string;

    let result = false;
    let isOverSendPoint = false;
    let isOutOfScope = false;
    let pointExclusiveControl = false;
    let res;

    try {
      res = await ThanksPointApi.postThanksPoint(
      sendPoint,
      title,
      message,
      parseInt(id)
      );
      result = res.result;
      isOverSendPoint = res.overSendPoint;
      isOutOfScope = res.outOfScope;
      pointExclusiveControl = res.pointExclusiveControl;
    } catch (e) {
      console.log(e.error);
    }

    if (res && res.status == 500) {
      if (this.ssoFlg) {
        // SSOログイン時は行き止まりエラー画面へ
        window.location.href = "/session-time-out/";
      } else {
        LocalStorage.removeAll();
        AuthApi.getLogout();
        auth.remove();
        window.location.href = "/system-error/";
      }
    }

    if (!result) {
      if (isOverSendPoint) {
        alert('送付ポイントが贈与可能ポイントを超えていました。');
      } else if (isOutOfScope) {
        alert(this.thanksPointName + 'の送付に失敗しました。');
      } else if (pointExclusiveControl) {
        window.location.href = "/thanks-point/user-selection/?point_exclusive_control=true"
      }
    return
    }

    LocalStorage.removeItem("points_to_show");
    LocalStorage.removeItem("title");
    LocalStorage.removeItem("message");

    const modalType = this.thanksPointApprovalEnabled ? 1 : 2;

    window.location.href = `${sitemap.THANKS_POINT_USER_SELECTION}?show_modal=${modalType}`;
  }
}
